import makeStyles from '@mui/styles/makeStyles';

// using classes to override default typography color
export const useStyles = makeStyles((theme) => ({
  error: {
    color: theme.palette.alert.error.content,
  },
  warning: {
    color: theme.palette.alert.warning.content
  }
}));
